export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_ALL_AS_READ = 'MARK_ALL_AS_READ';
export const RECEIVE_PUSH_NOTIFICATION = 'RECEIVE_PUSH_NOTIFICATION';
